import { makeStyles } from '@fluentui/react-components';
import { tokens } from '@bingads-webui-fluent-component/tokens';

import { Appearance } from './types';

export const useGlobalStyles = makeStyles({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    boxSizing: 'border-box',
    position: 'relative',
  },
});

export const useAppearanceStyles = makeStyles<Appearance>({
  default: {
    backgroundColor: tokens.adsui_colorBackgroundDefault,
  },
  elevated: {
    backgroundColor: tokens.adsui_colorBackgroundElevated,
    boxShadow: tokens.shadow4,
  },
  filled: {
    backgroundColor: tokens.adsui_colorBackgroundFilled,
  },
});
